import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name activeLocationService
     * @memberof app
     *
     * @description
     * Service to check the active path
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .service('activeLocationService', activeLocationService);

    function activeLocationService($location) {
        return {
            isActive: isActive
        };

        /**
         * Checks the first part of the path behind the #
         *
         * For example isActive('/reporting') for the reporting path.
         *
         * @param path
         * @returns {boolean}
         */
        function isActive(firstPartOfPath) {
            var currentLocation = $location
                .path()
                .substr(0, firstPartOfPath.length);
            return currentLocation === firstPartOfPath;
        }
    }
})();
